(() => {
  const hoverDelay = 220;
  const hoverTimers = new WeakMap();

  const hoverMedia = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  function closeItem(item) {
    if (!item) return;

    const timer = hoverTimers.get(item);

    if (timer) {
      clearTimeout(timer);
      hoverTimers.delete(item);
    }

    item.classList.remove('is-open');

    item
      .querySelector('[data-pf-mega-toggle]')
      ?.setAttribute('aria-expanded', 'false');

    const children = item.querySelector(
      '[data-pf-mega-children]'
    );

    if (children) {
      children.hidden = true;
    }
  }

  function openItem(item) {
    if (!item) return;

    const megaMenu = item.closest('[data-pf-mega]');

    /*
      Apenas uma expansão aberta de cada vez
      em todo o mega menu.
    */
    megaMenu
      ?.querySelectorAll('[data-pf-mega-item].is-open')
      .forEach((otherItem) => {
        if (otherItem !== item) {
          closeItem(otherItem);
        }
      });

    item.classList.add('is-open');

    item
      .querySelector('[data-pf-mega-toggle]')
      ?.setAttribute('aria-expanded', 'true');

    const children = item.querySelector(
      '[data-pf-mega-children]'
    );

    if (children) {
      children.hidden = false;
    }
  }

  /*
    DESKTOP:
    abre após um movimento intencional de 220 ms.
    Quando o rato sai, a expansão permanece aberta.
    Só fecha quando outra opção é aberta.
  */
  document.addEventListener('pointerover', (event) => {
    if (!hoverMedia.matches) return;

    const item = event.target.closest(
      '[data-pf-mega-item]'
    );

    if (!item) return;

    if (
      event.relatedTarget &&
      item.contains(event.relatedTarget)
    ) {
      return;
    }

    if (item.classList.contains('is-open')) {
      return;
    }

    const existingTimer = hoverTimers.get(item);

    if (existingTimer) {
      clearTimeout(existingTimer);
    }

    const timer = setTimeout(() => {
      openItem(item);
      hoverTimers.delete(item);
    }, hoverDelay);

    hoverTimers.set(item, timer);
  });

  /*
    Se o rato sair antes dos 220 ms,
    a opção não abre.
    Se já abriu, permanece aberta.
  */
  document.addEventListener('pointerout', (event) => {
    if (!hoverMedia.matches) return;

    const item = event.target.closest(
      '[data-pf-mega-item]'
    );

    if (!item) return;

    if (
      event.relatedTarget &&
      item.contains(event.relatedTarget)
    ) {
      return;
    }

    const timer = hoverTimers.get(item);

    if (timer) {
      clearTimeout(timer);
      hoverTimers.delete(item);
    }
  });

  /*
    Clique/toque no chevron.
  */
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(
      '[data-pf-mega-toggle]'
    );

    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();

    const item = toggle.closest(
      '[data-pf-mega-item]'
    );

    if (!item) return;

    if (item.classList.contains('is-open')) {
      closeItem(item);
    } else {
      openItem(item);
    }
  });

  /*
    Teclado.
  */
  document.addEventListener('focusin', (event) => {
    const item = event.target.closest(
      '[data-pf-mega-item]'
    );

    if (item) {
      openItem(item);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const item = event.target.closest?.(
      '[data-pf-mega-item]'
    );

    if (!item) return;

    closeItem(item);

    item
      .querySelector('[data-pf-mega-toggle]')
      ?.focus();
  });

  /*
    Ao fechar o mega menu principal,
    fecha todas as expansões.
  */
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;

      if (
        !(details instanceof HTMLDetailsElement) ||
        !details.matches(
          'details[is="details-mega"][level="top"]'
        ) ||
        details.open
      ) {
        return;
      }

      details
        .querySelectorAll('[data-pf-mega-item].is-open')
        .forEach(closeItem);
    },
    true
  );

  function initialize(root = document) {
    root
      .querySelectorAll?.('[data-pf-mega-item]')
      .forEach(closeItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialize()
    );
  } else {
    initialize();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialize(event.target);
    }
  );
})();
(() => {
  const OUTSIDE_DELAY = 70;
  const EDGE_DELAY = 110;
  const EDGE_SIZE = 18;
  const BRIDGE_TOLERANCE = 4;

  const closeTimers = new WeakMap();

  let animationFrame = 0;
  let pointerX = 0;
  let pointerY = 0;

  function clearCloseTimer(details) {
    const timer = closeTimers.get(details);

    if (timer) {
      clearTimeout(timer);
      closeTimers.delete(details);
    }
  }

  function closeMegaMenu(details) {
    if (!details) return;

    clearCloseTimer(details);

    if (details.open) {
      details.open = false;
    }
  }

  function scheduleClose(details, delay) {
    if (!details || closeTimers.has(details)) return;

    const timer = setTimeout(() => {
      closeMegaMenu(details);
    }, delay);

    closeTimers.set(details, timer);
  }

  function pointIsInside(rect, x, y) {
    return (
      x >= rect.left &&
      x <= rect.right &&
      y >= rect.top &&
      y <= rect.bottom
    );
  }

  function checkPointerPosition() {
    document
      .querySelectorAll(
        'details[is="details-mega"][level="top"][open]'
      )
      .forEach((details) => {
        const megaMenu = details.querySelector('.pf-mega');

        if (!megaMenu) return;

        const menuRect = megaMenu.getBoundingClientRect();
        const summary = details.querySelector(':scope > summary');
        const summaryRect = summary?.getBoundingClientRect();

        const insideMenu = pointIsInside(
          menuRect,
          pointerX,
          pointerY
        );

        const insideTrigger =
          summaryRect &&
          pointIsInside(
            summaryRect,
            pointerX,
            pointerY
          );

        /*
          Ponte invisível entre o botão Produtos
          e o início do mega menu.
        */
        const bridgeTop = summaryRect
          ? Math.min(summaryRect.bottom, menuRect.top) -
            BRIDGE_TOLERANCE
          : menuRect.top;

        const bridgeBottom = summaryRect
          ? Math.max(summaryRect.bottom, menuRect.top) +
            BRIDGE_TOLERANCE
          : menuRect.top;

        const insideBridge =
          Boolean(summaryRect) &&
          pointerX >= menuRect.left &&
          pointerX <= menuRect.right &&
          pointerY >= bridgeTop &&
          pointerY <= bridgeBottom;

        /*
          Sobre Produtos ou a atravessar o espaço
          até ao mega menu: manter sempre aberto.
        */
        if (insideTrigger || insideBridge) {
          clearCloseTimer(details);
          return;
        }

        /*
          Saiu completamente do mega menu:
          fechar rapidamente.
        */
        if (!insideMenu) {
          scheduleClose(details, OUTSIDE_DELAY);
          return;
        }

        /*
          Deteção antecipada apenas:
          - lateral esquerda;
          - lateral direita;
          - parte inferior.

          A extremidade superior não fecha o menu.
        */
        const nearExitEdge =
          pointerX <= menuRect.left + EDGE_SIZE ||
          pointerX >= menuRect.right - EDGE_SIZE ||
          pointerY >= menuRect.bottom - EDGE_SIZE;

        if (nearExitEdge) {
          scheduleClose(details, EDGE_DELAY);
        } else {
          clearCloseTimer(details);
        }
      });

    animationFrame = 0;
  }

  document.addEventListener(
    'pointermove',
    (event) => {
      pointerX = event.clientX;
      pointerY = event.clientY;

      if (!animationFrame) {
        animationFrame = requestAnimationFrame(
          checkPointerPosition
        );
      }
    },
    { passive: true }
  );

  document.addEventListener('pointerdown', (event) => {
    document
      .querySelectorAll(
        'details[is="details-mega"][level="top"][open]'
      )
      .forEach((details) => {
        if (!details.contains(event.target)) {
          closeMegaMenu(details);
        }
      });
  });

  document.documentElement.addEventListener(
    'mouseleave',
    () => {
      document
        .querySelectorAll(
          'details[is="details-mega"][level="top"][open]'
        )
        .forEach(closeMegaMenu);
    }
  );
})();